/*
* 运单整体声明周期状态枚举
* */
export enum OverallStatus {
    ASSIGNED='ASSIGNED',
    CREATED='CREATED',                   // 运单创建
    CANCELLED='CANCELLED',                 // 已取消
    ARRIVED_ORIGIN_HUB='ARRIVED_ORIGIN_HUB',        // 已入库_始发地HUB
    LINEHAUL_PENDING_SHIPMENT='LINEHAUL_PENDING_SHIPMENT', // 干线待发运
    FEEDER_PENDING_SHIPMENT='FEEDER_PENDING_SHIPMENT',   // 支线待发运
    // 过渡期兼容后端旧枚举名
    PENDING_SHIPMENT='PENDING_SHIPMENT',          // 待发运（旧名，等价于 FEEDER_PENDING_SHIPMENT）
    HANDED_OVER='HANDED_OVER',               // 已交接
    IN_TRANSIT='IN_TRANSIT',                // 运输中
    ARRIVED_DESTINATION_HUB='ARRIVED_DESTINATION_HUB',   // 已入库_目的地HUB
    ARRIVED_WHS='ARRIVED_WHS',               // 已入库_WHS
    WAITING_FOR_DELIVERY='WAITING_FOR_DELIVERY',      // 待派件
    DELIVERY_IN_PROGRESS='DELIVERY_IN_PROGRESS',      // 派件中
    PRE_DELIVERED='PRE_DELIVERED',               // 预妥投
    DELIVERED='DELIVERED',                 // 派件成功
    DELIVERY_FAILED='DELIVERY_FAILED',           // 派送失败
    PENDING_INTERCEPTION='PENDING_INTERCEPTION',      // 待拦截
    INTERCEPTED ='INTERCEPTED',               // 已拦截
    RETURNED='RETURNED',                   // 已退件
    DAMAGED='DAMAGED',                     // 已破损
    LOST='LOST'                            // 已丢失
}